import React, { createContext, useContext } from "react";
import { useEditor, useNode } from "@craftjs/core"; // We still need useNode for connectors.connect on the parent
import { WebsiteContext } from "@/pages/website/WebsiteProvider";
import RepeatSettings from "../settings/RepeatSettings";

export const RepeatContext = createContext<any>({});

const Repeater = ({ children }) => {
  const {
    id,
    connectors: { connect, drag },
  } = useNode((state) => {
    return {
      hasSelectedNode: state.events.selected,
      hasDraggedNode: state.events.dragged,
    };
  });
  const { query } = useEditor();
  const websiteContext = useContext(WebsiteContext);
  const isEditorEnabled = query.getOptions().enabled;

  if (!children) {
    return (
      <div ref={(ref) => connect(drag(ref))} style={{ border: "2px dashed blue", padding: "20px", textAlign: "center" }}>
        Drop a component here to repeat it based on data.
      </div>
    );
  }

  if (isEditorEnabled) {
    const links = websiteContext?.website?.settings?.links?.value;
    const hasLinks = Array.isArray(links) && links.length > 0;
    const mockItem = hasLinks ? links[0] : { title: "Ejemplo de Enlace", href: "#" };

    return (
      <div
        key={id}
        ref={(ref) => connect(drag(ref))}
        style={{
          border: "2px dashed blue",
          padding: "20px",
          borderRadius: "4px",
        }}
      >
        {!hasLinks && (
          <div
            style={{
              color: "#666",
              textAlign: "center",
              marginBottom: "12px",
              fontSize: "13px",
              fontWeight: "500",
              borderBottom: "1px dashed #ccc",
              paddingBottom: "8px",
            }}
          >
            No hay enlaces disponibles
          </div>
        )}
        <RepeatContext.Provider value={mockItem}>
          {children}
        </RepeatContext.Provider>
      </div>
    );
  }

  return (
    <div key={id} ref={(ref) => connect(drag(ref))}>
      {websiteContext?.website?.settings?.links?.value?.map((item) => (
        <RepeatContext.Provider value={{ ...item }}>{React.cloneElement(children)}</RepeatContext.Provider>
      ))}
    </div>
  );
};

Repeater.craft = {
  displayName: "Repetidor",
  props: {
    data: [],
  },
  related: {
    settings: RepeatSettings,
  },
  isDroppable: true,
};

export default Repeater;
